import { useEffect, useState } from "react";

const useWebSocket = (url, token) => {
  const [socket, setSocket] = useState(null);
  console.log(token)
  useEffect(() => {
    if (!token) {
      console.log("❌ Aucun token trouvé, WebSocket non initialisé.");
      setSocket(null); // Assure-toi que socket est null si pas de token
      return; // Ne crée pas la WebSocket si pas de token
    }

    const ws = new WebSocket(`${url}?token=${token}`);

    ws.onopen = () => {
      console.log("✅ WebSocket connection established.");
    };

    ws.onmessage = (event) => {
      console.log("📩 Message reçu depuis WebSocket :", JSON.parse(event.data));
    };

    ws.onerror = (error) => {
      console.error("❌ WebSocket error :", error);
    };

    ws.onclose = () => {
      console.log("🔴 WebSocket connection closed.");
    };

    setSocket(ws);

    return () => {
      console.log("🔄 Fermeture WebSocket...");
      ws.close();
    };
  }, [url, token]); // 🔥 WebSocket se réinitialise si `token` change

  return socket;
};

export default useWebSocket;
